/**
 * Glassmorphism スタイル定義
 */

import { CSSProperties } from 'react';

export const glassStyle: CSSProperties = {
  backdropFilter: 'blur(16px)',
  background: 'rgba(255, 255, 255, 0.5)',
};
